import React from "react";
import "./../../UaeAttestation/UaeService/UaeService.css";
import AustraliaBloreCertHead from "../../Australia/AustraliaBloreCert/AustraliaBloreCertHead";
import UkBloreCertMain from "./UkBloreCertMain";
const UkBloreCert = () => {
  return (
    <div className="uaeServiceContainer">
      <AustraliaBloreCertHead head="UK Apostille service in Bangalore for certificates" />
      <UkBloreCertMain />
    </div>
  );
};

export default UkBloreCert;
